<template>
    <div>
        <hts-form-select
            v-model="businesses"
            :query="findBusinesses"
            :filterable="true"
            :clearable="true"
            :label="$t('labels.business')"
            multiple
            key-id="_id"
            key-label="name"
            :selected-multiple="businessSelected"
            :disabled="disabled"
            :required="required" />
    </div>
</template>
<script setup lang="ts">
const props = defineProps({
  modelValue: {
    type: String,
    default: ''
  },
  businesses: {
    type: Array,
    default: () => []
  },
  nodeType: {
    type: String,
    required: true
  },
  businessSelected: {
    type: Array,
    required: false,
    default: () => []
  },
  disabled: {
    type: Boolean,
    default: false
  },
  required: {
    type: Boolean,
    default: true
  }
})

const { nodeType } = toRefs(props)

const businesses = ref(props.businesses)

const findBusinesses = async (s: string) => {
  const res = await $api($urlAdmin.business.selectByNodeTpe, { uriParams: { KEY: s, NODE_TYPE: nodeType.value } })
  const resData: any = res?.data.value
  if (resData.success) {
    return resData.data
  }
  return null
}

const emits = defineEmits(['update:modelValue'])

watch(businesses, (val) => {
  emits('update:modelValue', val)
})
</script>
